<template>
  <div class="popup_in">
    <div class="popup">
      <h2 class="title title--40">
        {{ title }}
        <br />
      </h2>
      <div class="popup-content">{{ content }}</div>
      <div class="flex flex--content--center">
        <a class="bt_blue" @click.prevent="$emit('close')">{{ buttonText }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      default: "אישור"
    }
  }
};
</script>

<style scoped>
.popup-content {
  margin-bottom: 30px;
}
</style>
